import React from "react"
import { useSelector } from "react-redux"
import { FaShoppingCart } from "react-icons/fa"
import { useHistory } from "react-router-dom"

import { IconButton } from "components"
import { haveAuth, movePreviousOrderToCartForEdit } from "utils"
import classes from "./KtOrderCheckoutButton.module.scss"

const KtOrderCheckoutButton = props => {
  const {
    tableOrder,
    tableDetails,
    subPaymentItems
  } = props

  const history = useHistory()

  const isOnline =
    useSelector(state =>
      state.internetStatus.online &&
      !state.internetStatus.forceOffline
    )

  const handlePress = () => {
    movePreviousOrderToCartForEdit(
      tableOrder,
      tableDetails.tableNumber,
      subPaymentItems || {}
    )

    history.push("/checkout")
  }

  const showCheckoutButton =
    !isOnline ||
    (haveAuth(["checkout"]) && subPaymentItems !== null)

  if (!showCheckoutButton) return null

  return (
    <IconButton
      icon={FaShoppingCart}
      size={13}
      color="white"
      onClick={handlePress}
      className={classes["icon"]}
    />
  )
}

export default KtOrderCheckoutButton